import { render, staticRenderFns } from "./SubmitBtn.vue?vue&type=template&id=15ef9f73&scoped=true"
import script from "./SubmitBtn.vue?vue&type=script&lang=js"
export * from "./SubmitBtn.vue?vue&type=script&lang=js"
import style0 from "./SubmitBtn.vue?vue&type=style&index=0&id=15ef9f73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ef9f73",
  null
  
)

export default component.exports